module.exports = __webpack_public_path__ + "static/media/img-destaque-internas.f9d07602.jpg";